import React from 'react';
import CSVImportPage from './pages/CSVImportPage';
import LabelsListPage from './pages/LabelsListPage';
import LabelsNotFoundListPage from './pages/LabelsNotFoundListPage';
import LabelAddPage from './pages/LabelAddPage';
import GitInfoPage from './pages/GitInfoPage';
import B2BRoutesModule from '../b2b-common/B2BRoutesModule';

const langRoutes = [
    { path: 'import-csv-file', element: <CSVImportPage />, visibility: 'private' },
    { path: 'labels', element: <LabelsListPage />, visibility: 'private' },
    { path: 'labels-not-found', element: <LabelsNotFoundListPage />, visibility: 'private' },
    { path: 'new', element: <LabelAddPage />, visibility: 'private' },
    { path: 'git-info', element: <GitInfoPage />, visibility: 'private' },
];

const B2BLanguages = () => {
    return <B2BRoutesModule routes={langRoutes} />;
}

export default B2BLanguages;